import react from 'react'

const FirebaseContext = react.createContext(null);

export default FirebaseContext;